import {axios} from "@/api/config";
// 查询检查项列表
export function listScore(params) {
  return axios.get('/tbBaseCheckScore/list', params, true);
}


